import { Expose } from "class-transformer";
import type { FeedbackEnum } from "../enums/feedback.enum";

export interface IUpdateMessageFeedbackDto {
  feedback: FeedbackEnum | null;
}

export class UpdateMessageFeedbackDto implements IUpdateMessageFeedbackDto {
  constructor(data?: IUpdateMessageFeedbackDto) {
    if (data) {
      this.feedback = data.feedback;
    }
  }

  @Expose()
  feedback!: FeedbackEnum | null;
}
